import Vue from 'vue'
import App from './App.vue'
import './plugin/vant'
import router from './router'
// import 'normalize.css/normalize.css'
import Vuex from 'vuex'
import store from './store'
// import 'lib-flexible'
Vue.use(Vuex)

import './utils/rem'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
